module.exports = "/images/paymongo.png?69a2ec7c7c070c2fc59356e2f4db4fdb";